import { countryDisplayName } from "../l10n/index.js";

/**
 * Get the proper address format
 *
 * @export
 * @param {*} address that needs to be formatted
 * @param {*} aboAddressFormat decides what address format is used
 * @param {*} locale locale code
 * @returns string
 */
export function getFormattedAddress(address, aboAddressFormat, locale = "") {
  if (address !== null && address !== undefined) {
    const defaultAddressOrder = ["address_lines", "municipality", "region", "postal_code", "country"];
    const activeDividers = aboAddressFormat.string
      ? aboAddressFormat.string.match(/[^}\\{]+(?={)/g)
      : [" | ", ", ", ", ", " | "];
    const activeAddressOrder = aboAddressFormat.string
      ? aboAddressFormat.string.match(/[^{\\}]+(?=})/g)
      : defaultAddressOrder;
    const addressDivider = aboAddressFormat.divider || ", ";
    let formattedAddress = "";

    activeAddressOrder.forEach((value, index) => {
      if (value === "address_lines" && address[value]) {
        const addressLineFormatted = address.address_lines
          .filter((addr) => addr)
          .toString()
          .replace(/,/g, addressDivider);
        formattedAddress += (formattedAddress ? activeDividers[index - 1] : "") + addressLineFormatted;
      } else if (!aboAddressFormat.string || defaultAddressOrder.includes(value)) {
        if (address[value] && address[value] !== "--") {
          let addressSegment = address[value];
          if (value === "country" && locale && addressSegment.length === 2) {
            addressSegment = countryDisplayName(locale, addressSegment);
          }
          formattedAddress += (formattedAddress ? activeDividers[index - 1] : "") + addressSegment;
        }
      } else formattedAddress += `${formattedAddress ? activeDividers[index - 1] : ""}{Invalid_Token}`;
    });
    return formattedAddress;
  }
  return null;
}

/**
 * Get the proper date format
 *
 * @export
 * @param {*} date
 * @param {*} locale
 * @param {*} pin
 * @returns string
 */
export function formatDate(date, locale, pin) {
  if (date === "--") {
    return "--";
  }

  if (date !== null && pin.length > 2) {
    return null;
  }

  if (date instanceof Date && !Number.isNaN(date.valueOf())) {
    const format = { month: "long", day: "2-digit", year: "numeric" };
    const dateFormat = new Intl.DateTimeFormat(locale, format);
    return dateFormat.format(date);
  }

  return "--";
}

/**
 * Get the proper name field for use in profile lists
 * @param {object} item the object with local and name
 * @param {string} locale the current viewing locale for the component
 * @param {string} confidentialUserTranslatedString the translated string for
 * ConfidentialUser
 * @param {object} aboData the object with profile information
 * @returns string
 */
export function listDisplayName(item, locale, confidentialUserTranslatedString, aboData, aboNameFormat) {
  let nameDetails = null;

  if (item.name_details) {
    nameDetails = locale.startsWith(aboData.preferredLanguageCode)
      ? item.name_details.locale_name
      : item.name_details.latin_name;
  }
  const validParams = ["given_name", "family_name"];
  const dashDash = "--";
  if (
    aboNameFormat &&
    nameDetails &&
    nameDetails[validParams[0]] &&
    nameDetails[validParams[1]] &&
    nameDetails[validParams[0]] !== dashDash &&
    nameDetails[validParams[1]] !== dashDash
  ) {
    const nameFormatArray = aboNameFormat.split(/{|}/);
    let formattedNames = "";
    if (nameFormatArray.length === 5) {
      nameFormatArray.forEach((value, index) => {
        if (index % 2) {
          if (nameDetails[value]) {
            formattedNames += nameDetails[value];
          } else formattedNames += "{Invalid_Token}";
        } else formattedNames += nameFormatArray[index];
      });
      return formattedNames;
    }
    return "Invalid_Entry";
  }

  const displayName = locale.startsWith(aboData.preferredLanguageCode) ? item.local_name : item.name;
  return !displayName || displayName === dashDash ? confidentialUserTranslatedString : displayName;
}
